import styles from './ArdixMark.module.css';

/** Marca Ardix inline (paths de ardix/marca/assinatura.svg, gerados por script). Sem fonte externa. */
const ABISSAL = '#0F2A3D';
const MARFIM = '#F6F2EA';
const CORAL = '#E2775A';

const WORDMARK_D =
  'M2.0 0.0 24.0 -72.0H44.300000000000004L66.3 0.0H52.300000000000004L32.7 -63.5H35.300000000000004L16.0 0.0ZM15.200000000000001 -15.0V-27.700000000000003H53.2V-15.0ZM71.8 0.0V-54.0H83.8V-40.800000000000004L82.5 -42.5Q83.55 -45.300000000000004 85.3 -47.60000000000001Q87.05 -49.900000000000006 89.6 -51.400000000000006Q91.55 -52.6 93.85 -53.275000000000006Q96.15 -53.95 98.6 -54.125Q101.05 -54.300000000000004 103.5 -54.0V-41.300000000000004Q101.25 -42.0 98.275 -41.775000000000006Q95.3 -41.550000000000004 92.9 -40.400000000000006Q90.5 -39.300000000000004 88.85 -37.475Q87.2 -35.65 86.35 -33.175Q85.5 -30.700000000000003 85.5 -27.6V0.0ZM131.4 1.5Q123.95 1.5 118.35 -2.25Q112.75 -6.0 109.625 -12.450000000000001Q106.5 -18.900000000000002 106.5 -27.0Q106.5 -35.25 109.675 -41.675Q112.85 -48.1 118.6 -51.8Q124.35 -55.5 132.1 -55.5Q139.8 -55.5 145.05 -51.75Q150.3 -48.0 153.0 -41.55Q155.7 -35.1 155.7 -27.0Q155.7 -18.900000000000002 152.975 -12.450000000000001Q150.25 -6.0 144.85 -2.25Q139.45 1.5 131.4 1.5ZM133.6 -10.600000000000001Q138.15 -10.600000000000001 140.875 -12.650000000000002Q143.6 -14.700000000000001 144.8 -18.400000000000002Q146.0 -22.1 146.0 -27.0Q146.0 -31.900000000000002 144.8 -35.6Q143.6 -39.300000000000004 140.975 -41.35000000000001Q138.35 -43.400000000000006 134.1 -43.400000000000006Q129.55 -43.400000000000006 126.625 -41.175000000000004Q123.7 -38.95 122.30000000000001 -35.225Q120.9 -31.5 120.9 -27.0Q120.9 -22.450000000000003 122.25 -18.725Q123.6 -15.0 126.39999999999999 -12.8Q129.2 -10.600000000000001 133.6 -10.600000000000001ZM146.0 0.0V-37.0H144.3V-72.0H158.0V0.0ZM169.5 0.0V-54.0H183.1V0.0ZM188.6 0.0 207.9 -27.3 189.0 -54.0H205.0L215.8 -38.0L226.4 -54.0H242.4L223.5 -27.3L242.9 0.0H226.9L215.8 -16.6L204.6 0.0Z';
const PINGO_D = 'M169.50 -67.50 A6.80 6.80 0 1 1 183.10 -67.50 A6.80 6.80 0 1 1 169.50 -67.50 Z';

export function ArdixMark({
  tone,
  variant,
  className,
}: {
  tone: 'light' | 'dark';
  variant: 'full' | 'symbol';
  className?: string;
}) {
  const fill = tone === 'dark' ? ABISSAL : MARFIM;
  const symbol = (
    <>
      <path d="M46.482 49.845 A40 40 0 0 0 53.518 49.845 L51.458 45.97 A36 36 0 0 1 48.542 45.97 Z" fill={CORAL} />
      <path d="M40.486 61.122 A52 52 0 0 0 59.514 61.122 L57.04 56.47 A47 47 0 0 1 42.96 56.47 Z" fill={CORAL} />
      <path d="M33.667 73.947 A66 66 0 0 0 66.333 73.947 L62.452 66.648 A58 58 0 0 1 37.548 66.648 Z" fill={CORAL} />
      <path d="M50 10 L9.625 85.933 A86 86 0 0 0 21.568 91.164 L50 37.691 L78.432 91.164 A86 86 0 0 0 90.375 85.933 L90.375 85.933 Z" fill={fill} />
    </>
  );
  const cls = className ? `${styles.mark} ${className}` : styles.mark;
  if (variant === 'symbol') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" role="img" aria-label="Ardix" className={cls}>
        {symbol}
      </svg>
    );
  }
  // layout de ardix/marca/assinatura.svg
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -92.00 378.94 112.00" role="img" aria-label="Ardix" className={cls}>
      <g transform="translate(0 -90.00) scale(1.0800)">{symbol}</g>
      <g transform="translate(131.04 0)">
        <path d={WORDMARK_D} fill={fill} />
        <path d={PINGO_D} fill={CORAL} />
      </g>
    </svg>
  );
}
